import { render } from "./ThePanelFooter.vue?vue&type=template&id=513b7d3d"
import script from "./ThePanelFooter.vue?vue&type=script&lang=js"
export * from "./ThePanelFooter.vue?vue&type=script&lang=js"
script.render = render

export default script